import { ArrowLeft, ShieldCheck, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LegalPages.css";
import { Helmet } from "react-helmet-async";

export function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <>
     <Helmet>
      <title>{t("seo.privacy.title")}</title>

      <meta
        name="description"
        content={t("seo.privacy.description")}
      />

      <link
        rel="canonical"
        href="https://francescotransfers.com/privacy"
      />
    </Helmet>
    <main className="legal-page">
      <div className="legal-page-container">
        <Link to="/" className="legal-back-link">
          <ArrowLeft size={18} />
          <span>{t("privacy.back")}</span>
        </Link>

        <header className="legal-header">
          <div className="legal-icon">
            <Lock size={30} />
          </div>

          <div>
            <span className="legal-eyebrow">
              {t("privacy.eyebrow")}
            </span>

            <h1>{t("privacy.title")}</h1>

            <p>{t("privacy.intro")}</p>
          </div>
        </header>

        <div className="legal-content">
          <section className="legal-section">
            <h2>{t("privacy.data.title")}</h2>
            <p>{t("privacy.data.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.purpose.title")}</h2>
            <p>{t("privacy.purpose.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.sharing.title")}</h2>
            <p>{t("privacy.sharing.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.retention.title")}</h2>
            <p>{t("privacy.retention.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.rights.title")}</h2>
            <p>{t("privacy.rights.description")}</p>
          </section>

          <section className="legal-section">
            <h2>{t("privacy.contact.title")}</h2>
            <p>{t("privacy.contact.description")}</p>
          </section>

          <aside className="legal-notice">
            <ShieldCheck size={22} />

            <div>
              <strong>{t("privacy.notice.title")}</strong>
              <p>{t("privacy.notice.description")}</p>
            </div>
          </aside>

          <p className="legal-updated">
            {t("privacy.lastUpdated")}
          </p>
        </div>
      </div>
    </main>
    </>
  );
}